import LanguageDetector from 'i18next-browser-languagedetector';
import type { DetectorOptions, CustomDetector } from 'i18next-browser-languagedetector';
import { SUPPORTED_LANGUAGES, type Language } from './constants';

/**
 * Custom detector for User Profile language preference.
 * Checks localStorage for cached profile language (stored by useLanguage hook).
 * This allows User Profile to be checked before Navigator fallback.
 */
const userProfileDetector: CustomDetector = {
  name: 'userProfile',
  lookup() {
    try {
      const cachedLang = localStorage.getItem('codemerlin-language');
      if (cachedLang && SUPPORTED_LANGUAGES.includes(cachedLang as Language)) {
        return cachedLang;
      }
    } catch {
      /* Safari private mode / storage blocked */
    }
    return undefined;
  },
  cacheUserLanguage(lng: string) {
    try {
      localStorage.setItem('codemerlin-language', lng);
    } catch {
      /* ignore */
    }
  },
};

export const detectionOptions: DetectorOptions = {
  // Detection order: URL > localStorage > User Profile > Navigator
  // Matches plan specification: URL > localStorage > User Profile > Navigator
  order: ['querystring', 'localStorage', 'userProfile', 'navigator'],
  lookupQuerystring: 'lng',
  lookupLocalStorage: 'codemerlin-language',
  caches: ['localStorage'],
  excludeCacheFor: ['cimode'], // 'cimode' is for testing
};

/**
 * Create and configure language detector with custom detectors.
 * Must be called before i18n.init() to register custom detectors.
 */
export function createLanguageDetector(): LanguageDetector {
  const detector = new LanguageDetector();
  detector.addDetector(userProfileDetector);
  return detector;
}
